import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

const defaultProps = {
  className: '',
  onClick: () => {},
  style: {},
};

function Row({ className, children, onClick, style }) {
  return (
    <div
      style={style}
      className={`flex-wrapper flex-wrapper-row ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;

export default Row;
